var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "van-popup",
        {
          style: { width: "90%", backgroundColor: "#eae9e9" },
          attrs: { "close-on-click-overlay": false, round: "" },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: "新增票据",
              "left-text": "取消",
              "right-text": "保存并关闭",
            },
            on: {
              "click-left": _vm.close,
              "click-right": _vm.relativeFlowPopupSubmit,
            },
          }),
          _c(
            "div",
            { staticClass: "h-vh-70", staticStyle: { "overflow-y": "auto" } },
            [
              !_vm.file
                ? _c(
                    "van-uploader",
                    {
                      staticClass: "Muploader",
                      attrs: {
                        accept: ".pdf",
                        "preview-image": false,
                        "after-read": (file) => {
                          _vm.afterAddFile(file)
                        },
                        "before-read": _vm.beforeRead,
                        "preview-full-image": false,
                      },
                      model: {
                        value: _vm.imageFileList,
                        callback: function ($$v) {
                          _vm.imageFileList = $$v
                        },
                        expression: "imageFileList",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "bg-FF p-70 text-center h-vh-20",
                          staticStyle: { width: "90vw" },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("van-icon", {
                                attrs: {
                                  size: "50",
                                  color: "#ccc",
                                  name: "upgrade",
                                },
                              }),
                              _c("div", { staticClass: "font-40 cor-CC" }, [
                                _vm._v("上传发票"),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.file
                ? _c(
                    "div",
                    { staticClass: "pdfBox" },
                    [
                      _c("PdfPreview", {
                        ref: "PdfPreview",
                        attrs: { "pdf-url": _vm.pdfSrc },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "van-form",
                {
                  ref: "form",
                  attrs: {
                    "show-error": false,
                    "error-message-align": "right",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "p-10" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "m-t-20 font-32 font-weight-500 cor-00",
                        },
                        [_vm._v("个人信息")]
                      ),
                      _c(
                        "van-cell-group",
                        { staticClass: "m-t-20" },
                        [
                          _c("van-field", {
                            attrs: {
                              rules: [
                                { required: true, message: "部门不能为空" },
                              ],
                              required: true,
                              name: "flowName",
                              label: "部门",
                              placeholder: "部门",
                              "input-align": "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "input",
                                fn: function () {
                                  return [
                                    _c("view-item", {
                                      attrs: {
                                        "tree-data": _vm.deptId.data,
                                        value: _vm.formData.deptId,
                                        placeholder: "请选择部门",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          _vm.deptId.show = true
                                        },
                                      },
                                    }),
                                    _c(
                                      "van-popup",
                                      {
                                        attrs: { position: "bottom" },
                                        model: {
                                          value: _vm.deptId.show,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.deptId, "show", $$v)
                                          },
                                          expression: "deptId.show",
                                        },
                                      },
                                      [
                                        _c("van-nav-bar", {
                                          attrs: {
                                            title: "选择部门",
                                            "left-text": "取消",
                                            "right-text": "确定",
                                          },
                                          on: {
                                            "click-left": function ($event) {
                                              _vm.deptId.show = false
                                            },
                                            "click-right":
                                              _vm.handlePopupSubmit,
                                          },
                                        }),
                                        _c("van-search", {
                                          attrs: {
                                            clearable: "",
                                            shape: "round",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.treeSearch(
                                                $event,
                                                _vm.$refs.ocr_dept_tree
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.deptId.filterText,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.deptId,
                                                "filterText",
                                                $$v
                                              )
                                            },
                                            expression: "deptId.filterText",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "h-vh-35",
                                            staticStyle: {
                                              "overflow-y": "auto",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "p-10" },
                                              [
                                                _c("el-tree", {
                                                  ref: "ocr_dept_tree",
                                                  attrs: {
                                                    "node-key": "id",
                                                    "check-strictly": "",
                                                    data: _vm.deptId.data,
                                                    "filter-node-method":
                                                      _vm.filterNode,
                                                    "check-on-click-node": "",
                                                    "show-checkbox": "",
                                                  },
                                                  on: {
                                                    "check-change": function (
                                                      $event
                                                    ) {
                                                      return _vm.singleChoice(
                                                        $event,
                                                        _vm.$refs.ocr_dept_tree
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.formData.deptId,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "deptId", $$v)
                              },
                              expression: "formData.deptId",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "m-t-20 font-32 font-weight-500 cor-00",
                        },
                        [_vm._v("发票信息")]
                      ),
                      _vm.formData.invoiceType == 3
                        ? _c(
                            "van-cell-group",
                            { staticClass: "m-t-20" },
                            [
                              _c("van-field", {
                                attrs: {
                                  "input-align": "right",
                                  name: "invoiceType",
                                  rules: [
                                    {
                                      required: true,
                                      message: "发票类型不能为空",
                                    },
                                  ],
                                  required: true,
                                  value: _vm.formData.invoiceType,
                                  label: "发票类型",
                                  placeholder: "请选择发票类型",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "input",
                                      fn: function () {
                                        return [
                                          _c("view-item", {
                                            attrs: {
                                              value:
                                                _vm.formData.invoiceTypeName,
                                              placeholder: "请选择发票类型",
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                _vm.invoiceType.show = true
                                              },
                                            },
                                          }),
                                          _c(
                                            "van-popup",
                                            {
                                              attrs: { position: "bottom" },
                                              model: {
                                                value: _vm.invoiceType.show,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.invoiceType,
                                                    "show",
                                                    $$v
                                                  )
                                                },
                                                expression: "invoiceType.show",
                                              },
                                            },
                                            [
                                              _c("van-nav-bar", {
                                                attrs: {
                                                  title: "选择发票类型",
                                                  "left-text": "取消",
                                                  "right-text": "确定",
                                                },
                                                on: {
                                                  "click-left": function (
                                                    $event
                                                  ) {
                                                    _vm.invoiceType.show = false
                                                  },
                                                  "click-right": function (
                                                    $event
                                                  ) {
                                                    return _vm.popupSubmit(
                                                      "invoiceType",
                                                      {
                                                        label: "dictLable",
                                                        value: "dictValue",
                                                      }
                                                    )
                                                  },
                                                },
                                              }),
                                              _c("van-picker", {
                                                ref: "invoiceType",
                                                attrs: {
                                                  "value-key": "dictLabel",
                                                  columns: _vm.invoiceType.data,
                                                },
                                                on: {
                                                  cancel: function ($event) {
                                                    _vm.invoiceType.show = false
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1446257845
                                ),
                              }),
                              _c("van-field", {
                                attrs: {
                                  "input-align": "right",
                                  name: "invoiceTitle",
                                  rules: [
                                    {
                                      required: true,
                                      message: "发票抬头不能为空",
                                    },
                                  ],
                                  required: true,
                                  value: _vm.formData.invoiceTitle,
                                  label: "发票抬头",
                                  placeholder: "请选择发票抬头",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "input",
                                      fn: function () {
                                        return [
                                          _c("view-item", {
                                            attrs: {
                                              value: _vm.formData.invoiceTitle,
                                              placeholder: "请选择发票抬头",
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                _vm.invoiceTitle.show = true
                                              },
                                            },
                                          }),
                                          _c(
                                            "van-popup",
                                            {
                                              attrs: { position: "bottom" },
                                              model: {
                                                value: _vm.invoiceTitle.show,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.invoiceTitle,
                                                    "show",
                                                    $$v
                                                  )
                                                },
                                                expression: "invoiceTitle.show",
                                              },
                                            },
                                            [
                                              _c("van-nav-bar", {
                                                attrs: {
                                                  title: "选择发票抬头",
                                                  "left-text": "取消",
                                                  "right-text": "确定",
                                                },
                                                on: {
                                                  "click-left": function (
                                                    $event
                                                  ) {
                                                    _vm.invoiceTitle.show = false
                                                  },
                                                  "click-right": function (
                                                    $event
                                                  ) {
                                                    return _vm.popupSubmit(
                                                      "invoiceTitle"
                                                    )
                                                  },
                                                },
                                              }),
                                              _c("van-search", {
                                                attrs: {
                                                  clearable: "",
                                                  shape: "round",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.pickerSearch(
                                                      $event,
                                                      _vm.invoiceTitle,
                                                      "unitName"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.invoiceTitle.filterText,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.invoiceTitle,
                                                      "filterText",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "invoiceTitle.filterText",
                                                },
                                              }),
                                              _c("van-picker", {
                                                ref: "invoiceTitle",
                                                attrs: {
                                                  "value-key": "unitName",
                                                  columns:
                                                    _vm.invoiceTitle
                                                      .filteredData,
                                                },
                                                on: {
                                                  cancel: function ($event) {
                                                    _vm.invoiceTitle.show = false
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3249451318
                                ),
                              }),
                              _c("van-field", {
                                attrs: {
                                  rules: _vm.formRules.buyerTax,
                                  name: "buyerTax",
                                  required: true,
                                  maxlength: 20,
                                  placeholder: "请输入纳税人识别号",
                                  label: "纳税人识别号",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.buyerTax,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "buyerTax", $$v)
                                  },
                                  expression: "formData.buyerTax",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  type: "number",
                                  rules: [
                                    {
                                      required: true,
                                      message: "发票号码不能为空",
                                    },
                                  ],
                                  name: "invoiceCode",
                                  required: true,
                                  maxlength: 20,
                                  placeholder: "请输入发票号码",
                                  label: "发票号码",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.invoiceCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "invoiceCode", $$v)
                                  },
                                  expression: "formData.invoiceCode",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  rules: [
                                    {
                                      required: true,
                                      message: "开票日期不能为空",
                                    },
                                  ],
                                  required: true,
                                  name: "invoiceDate",
                                  label: "开票日期",
                                  placeholder: "开票日期",
                                  "input-align": "right",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "input",
                                      fn: function () {
                                        return [
                                          _c("view-item", {
                                            attrs: {
                                              value: _vm.formData.invoiceDate,
                                              placeholder: "请选择开票日期",
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                _vm.invoiceDate.show = true
                                              },
                                            },
                                          }),
                                          _c("van-calendar", {
                                            ref: "invoiceDate",
                                            attrs: {
                                              "min-date":
                                                _vm.invoiceDate.minDate,
                                              "show-confirm": false,
                                              title: "选择开票日期",
                                            },
                                            on: {
                                              confirm: _vm.invoiceDateConfirm,
                                            },
                                            model: {
                                              value: _vm.invoiceDate.show,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.invoiceDate,
                                                  "show",
                                                  $$v
                                                )
                                              },
                                              expression: "invoiceDate.show",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2970294313
                                ),
                                model: {
                                  value: _vm.formData.invoiceDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "invoiceDate", $$v)
                                  },
                                  expression: "formData.invoiceDate",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  "input-align": "right",
                                  name: "isElectronic",
                                  rules: [
                                    { required: true, message: "不能为空" },
                                  ],
                                  required: true,
                                  value: _vm.formData.isElectronic,
                                  label: "是否电子票",
                                  placeholder: "请选择是否电子票",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "input",
                                      fn: function () {
                                        return [
                                          _c("view-item", {
                                            attrs: {
                                              value:
                                                _vm.formData.isElectronicName,
                                              placeholder: "请选择是否电子票",
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                _vm.isElectronic.show = true
                                              },
                                            },
                                          }),
                                          _c(
                                            "van-popup",
                                            {
                                              attrs: { position: "bottom" },
                                              model: {
                                                value: _vm.isElectronic.show,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.isElectronic,
                                                    "show",
                                                    $$v
                                                  )
                                                },
                                                expression: "isElectronic.show",
                                              },
                                            },
                                            [
                                              _c("van-nav-bar", {
                                                attrs: {
                                                  title: "选择是否电子票",
                                                  "left-text": "取消",
                                                  "right-text": "确定",
                                                },
                                                on: {
                                                  "click-left": function (
                                                    $event
                                                  ) {
                                                    _vm.isElectronic.show = false
                                                  },
                                                  "click-right": function (
                                                    $event
                                                  ) {
                                                    return _vm.popupSubmit(
                                                      "isElectronic",
                                                      {
                                                        label: "dictLable",
                                                        value: "dictValue",
                                                      }
                                                    )
                                                  },
                                                },
                                              }),
                                              _c("van-picker", {
                                                ref: "isElectronic",
                                                attrs: {
                                                  "value-key": "dictLabel",
                                                  columns:
                                                    _vm.isElectronic.data,
                                                },
                                                on: {
                                                  cancel: function ($event) {
                                                    _vm.isElectronic.show = false
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1851377589
                                ),
                              }),
                              _c("van-field", {
                                attrs: {
                                  type: "number",
                                  name: "ticketPrice",
                                  rules: [
                                    { required: true, message: "金额不能为空" },
                                  ],
                                  required: true,
                                  maxlength: 20,
                                  placeholder: "请输入金额",
                                  label: "金额",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.ticketPrice,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "ticketPrice", $$v)
                                  },
                                  expression: "formData.ticketPrice",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  required: true,
                                  name: "travelInformation",
                                  type: "textarea",
                                  maxlength: "100",
                                  rows: "3",
                                  rules: [
                                    {
                                      required: true,
                                      message: "行程信息不能为空",
                                    },
                                  ],
                                  autosize: "",
                                  label: "行程信息",
                                  "show-word-limit": "",
                                  placeholder: "请输入行程信息",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.travelInformation,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "travelInformation",
                                      $$v
                                    )
                                  },
                                  expression: "formData.travelInformation",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  rules: [
                                    {
                                      required: true,
                                      message: "乘车时间不能为空",
                                    },
                                  ],
                                  required: true,
                                  name: "travelTime",
                                  label: "乘车时间",
                                  placeholder: "乘车时间",
                                  "input-align": "right",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "input",
                                      fn: function () {
                                        return [
                                          _c("view-item", {
                                            attrs: {
                                              value: _vm.formData.travelTime,
                                              placeholder: "请选择乘车时间",
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                _vm.travelTime.show = true
                                              },
                                            },
                                          }),
                                          _c("van-calendar", {
                                            ref: "travelTime",
                                            attrs: {
                                              "min-date":
                                                _vm.travelTime.minDate,
                                              "show-confirm": false,
                                              title: "选择乘车时间",
                                            },
                                            on: {
                                              confirm: _vm.travelTimeConfirm,
                                            },
                                            model: {
                                              value: _vm.travelTime.show,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.travelTime,
                                                  "show",
                                                  $$v
                                                )
                                              },
                                              expression: "travelTime.show",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  991461257
                                ),
                                model: {
                                  value: _vm.formData.travelTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "travelTime", $$v)
                                  },
                                  expression: "formData.travelTime",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  rules: [
                                    {
                                      required: true,
                                      message: "乘车人不能为空",
                                    },
                                  ],
                                  name: "passenger",
                                  required: true,
                                  maxlength: 20,
                                  placeholder: "请输入乘车人",
                                  label: "乘车人",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.passenger,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "passenger", $$v)
                                  },
                                  expression: "formData.passenger",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm.formData.invoiceType == 4
                        ? _c(
                            "van-cell-group",
                            { staticClass: "m-t-20" },
                            [
                              _c("van-field", {
                                attrs: {
                                  "input-align": "right",
                                  name: "invoiceType",
                                  rules: [
                                    {
                                      required: true,
                                      message: "发票类型不能为空",
                                    },
                                  ],
                                  required: true,
                                  value: _vm.formData.invoiceType,
                                  label: "发票类型",
                                  placeholder: "请选择发票类型",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "input",
                                    fn: function () {
                                      return [
                                        _c("view-item", {
                                          attrs: {
                                            value: _vm.formData.invoiceTypeName,
                                            placeholder: "请选择发票类型",
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              _vm.invoiceType.show = true
                                            },
                                          },
                                        }),
                                        _c(
                                          "van-popup",
                                          {
                                            attrs: { position: "bottom" },
                                            model: {
                                              value: _vm.invoiceType.show,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.invoiceType,
                                                  "show",
                                                  $$v
                                                )
                                              },
                                              expression: "invoiceType.show",
                                            },
                                          },
                                          [
                                            _c("van-nav-bar", {
                                              attrs: {
                                                title: "选择发票类型",
                                                "left-text": "取消",
                                                "right-text": "确定",
                                              },
                                              on: {
                                                "click-left": function (
                                                  $event
                                                ) {
                                                  _vm.invoiceType.show = false
                                                },
                                                "click-right": function (
                                                  $event
                                                ) {
                                                  return _vm.popupSubmit(
                                                    "invoiceType",
                                                    {
                                                      label: "dictLable",
                                                      value: "dictValue",
                                                    }
                                                  )
                                                },
                                              },
                                            }),
                                            _c("van-picker", {
                                              ref: "invoiceType",
                                              attrs: {
                                                "value-key": "dictLabel",
                                                columns: _vm.invoiceType.data,
                                              },
                                              on: {
                                                cancel: function ($event) {
                                                  _vm.invoiceType.show = false
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                              _c("van-field", {
                                attrs: {
                                  "input-align": "right",
                                  name: "invoiceTitle",
                                  rules: [
                                    {
                                      required: true,
                                      message: "发票抬头不能为空",
                                    },
                                  ],
                                  required: true,
                                  value: _vm.formData.invoiceTitle,
                                  label: "发票抬头",
                                  placeholder: "请选择发票抬头",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "input",
                                    fn: function () {
                                      return [
                                        _c("view-item", {
                                          attrs: {
                                            value: _vm.formData.invoiceTitle,
                                            placeholder: "请选择发票抬头",
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              _vm.invoiceTitle.show = true
                                            },
                                          },
                                        }),
                                        _c(
                                          "van-popup",
                                          {
                                            attrs: { position: "bottom" },
                                            model: {
                                              value: _vm.invoiceTitle.show,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.invoiceTitle,
                                                  "show",
                                                  $$v
                                                )
                                              },
                                              expression: "invoiceTitle.show",
                                            },
                                          },
                                          [
                                            _c("van-nav-bar", {
                                              attrs: {
                                                title: "选择发票抬头",
                                                "left-text": "取消",
                                                "right-text": "确定",
                                              },
                                              on: {
                                                "click-left": function (
                                                  $event
                                                ) {
                                                  _vm.invoiceTitle.show = false
                                                },
                                                "click-right": function (
                                                  $event
                                                ) {
                                                  return _vm.popupSubmit(
                                                    "invoiceTitle"
                                                  )
                                                },
                                              },
                                            }),
                                            _c("van-search", {
                                              attrs: {
                                                clearable: "",
                                                shape: "round",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.pickerSearch(
                                                    $event,
                                                    _vm.invoiceTitle,
                                                    "unitName"
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.invoiceTitle.filterText,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.invoiceTitle,
                                                    "filterText",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "invoiceTitle.filterText",
                                              },
                                            }),
                                            _c("van-picker", {
                                              ref: "invoiceTitle",
                                              attrs: {
                                                "value-key": "unitName",
                                                columns:
                                                  _vm.invoiceTitle.filteredData,
                                              },
                                              on: {
                                                cancel: function ($event) {
                                                  _vm.invoiceTitle.show = false
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                              _c("van-field", {
                                attrs: {
                                  rules: _vm.formRules.buyerTax,
                                  name: "buyerTax",
                                  required: true,
                                  maxlength: 20,
                                  placeholder: "请输入纳税人识别号",
                                  label: "纳税人识别号",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.buyerTax,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "buyerTax", $$v)
                                  },
                                  expression: "formData.buyerTax",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  type: "number",
                                  rules: [
                                    {
                                      required: true,
                                      message: "发票号码不能为空",
                                    },
                                  ],
                                  name: "invoiceCode",
                                  required: true,
                                  maxlength: 20,
                                  placeholder: "请输入发票号码",
                                  label: "发票号码",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.invoiceCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "invoiceCode", $$v)
                                  },
                                  expression: "formData.invoiceCode",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  rules: [
                                    {
                                      required: true,
                                      message: "开票日期不能为空",
                                    },
                                  ],
                                  required: true,
                                  name: "invoiceDate",
                                  label: "开票日期",
                                  placeholder: "开票日期",
                                  "input-align": "right",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "input",
                                    fn: function () {
                                      return [
                                        _c("view-item", {
                                          attrs: {
                                            value: _vm.formData.invoiceDate,
                                            placeholder: "请选择开票日期",
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              _vm.invoiceDate.show = true
                                            },
                                          },
                                        }),
                                        _c("van-calendar", {
                                          ref: "invoiceDate",
                                          attrs: {
                                            "min-date": _vm.invoiceDate.minDate,
                                            "show-confirm": false,
                                            title: "选择开票日期",
                                          },
                                          on: {
                                            confirm: _vm.invoiceDateConfirm,
                                          },
                                          model: {
                                            value: _vm.invoiceDate.show,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.invoiceDate,
                                                "show",
                                                $$v
                                              )
                                            },
                                            expression: "invoiceDate.show",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.formData.invoiceDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "invoiceDate", $$v)
                                  },
                                  expression: "formData.invoiceDate",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  "input-align": "right",
                                  name: "isElectronic",
                                  rules: [
                                    { required: true, message: "不能为空" },
                                  ],
                                  required: true,
                                  value: _vm.formData.isElectronic,
                                  label: "是否电子票",
                                  placeholder: "请选择是否电子票",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "input",
                                    fn: function () {
                                      return [
                                        _c("view-item", {
                                          attrs: {
                                            value:
                                              _vm.formData.isElectronicName,
                                            placeholder: "请选择是否电子票",
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              _vm.isElectronic.show = true
                                            },
                                          },
                                        }),
                                        _c(
                                          "van-popup",
                                          {
                                            attrs: { position: "bottom" },
                                            model: {
                                              value: _vm.isElectronic.show,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.isElectronic,
                                                  "show",
                                                  $$v
                                                )
                                              },
                                              expression: "isElectronic.show",
                                            },
                                          },
                                          [
                                            _c("van-nav-bar", {
                                              attrs: {
                                                title: "选择是否电子票",
                                                "left-text": "取消",
                                                "right-text": "确定",
                                              },
                                              on: {
                                                "click-left": function (
                                                  $event
                                                ) {
                                                  _vm.isElectronic.show = false
                                                },
                                                "click-right": function (
                                                  $event
                                                ) {
                                                  return _vm.popupSubmit(
                                                    "isElectronic",
                                                    {
                                                      label: "dictLable",
                                                      value: "dictValue",
                                                    }
                                                  )
                                                },
                                              },
                                            }),
                                            _c("van-picker", {
                                              ref: "isElectronic",
                                              attrs: {
                                                "value-key": "dictLabel",
                                                columns: _vm.isElectronic.data,
                                              },
                                              on: {
                                                cancel: function ($event) {
                                                  _vm.isElectronic.show = false
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                              _c("van-field", {
                                attrs: {
                                  type: "number",
                                  name: "ticketPrice",
                                  rules: [
                                    {
                                      required: true,
                                      message: "机票金额不能为空",
                                    },
                                  ],
                                  required: true,
                                  maxlength: 20,
                                  placeholder: "请输入机票金额",
                                  label: "机票金额",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.ticketPrice,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "ticketPrice", $$v)
                                  },
                                  expression: "formData.ticketPrice",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  type: "number",
                                  name: "fuelFee",
                                  rules: [
                                    {
                                      required: true,
                                      message: "燃油附加费不能为空",
                                    },
                                  ],
                                  required: true,
                                  maxlength: 20,
                                  placeholder: "请输入燃油附加费",
                                  label: "燃油附加费",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.fuelFee,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "fuelFee", $$v)
                                  },
                                  expression: "formData.fuelFee",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  type: "number",
                                  name: "civilFund",
                                  rules: [
                                    {
                                      required: true,
                                      message: "民航发展基金不能为空",
                                    },
                                  ],
                                  required: true,
                                  maxlength: 20,
                                  placeholder: "请输入民航发展基金",
                                  label: "民航发展基金",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.civilFund,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "civilFund", $$v)
                                  },
                                  expression: "formData.civilFund",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  type: "number",
                                  name: "invoiceAmount",
                                  rules: [
                                    {
                                      required: true,
                                      message: "合计金额不能为空",
                                    },
                                  ],
                                  required: true,
                                  maxlength: 20,
                                  placeholder: "请输入合计金额",
                                  label: "合计金额",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.invoiceAmount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "invoiceAmount", $$v)
                                  },
                                  expression: "formData.invoiceAmount",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  type: "number",
                                  name: "taxRate",
                                  rules: [
                                    {
                                      required: true,
                                      message: "增值税税率不能为空",
                                    },
                                  ],
                                  required: true,
                                  maxlength: 20,
                                  placeholder: "请输入增值税税率",
                                  label: "增值税税率",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.taxRate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "taxRate", $$v)
                                  },
                                  expression: "formData.taxRate",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  name: "taxAmount",
                                  rules: [
                                    {
                                      required: true,
                                      message: "增值税税额不能为空",
                                    },
                                  ],
                                  required: true,
                                  maxlength: 20,
                                  placeholder: "请输入增值税税额",
                                  label: "增值税税额",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.taxAmount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "taxAmount", $$v)
                                  },
                                  expression: "formData.taxAmount",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  type: "number",
                                  name: "otherFees",
                                  rules: [
                                    {
                                      required: false,
                                      message: "其他税费不能为空",
                                    },
                                  ],
                                  required: false,
                                  maxlength: 20,
                                  placeholder: "请输入其他税费",
                                  label: "其他税费",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.otherFees,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "otherFees", $$v)
                                  },
                                  expression: "formData.otherFees",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  rules: [
                                    {
                                      required: true,
                                      message: "填开单位不能为空",
                                    },
                                  ],
                                  required: true,
                                  name: "seller",
                                  placeholder: "请输入填开单位",
                                  label: "填开单位",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.seller,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "seller", $$v)
                                  },
                                  expression: "formData.seller",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  rules: [
                                    {
                                      required: true,
                                      message: "乘机人不能为空",
                                    },
                                  ],
                                  required: true,
                                  name: "passenger",
                                  placeholder: "请输入乘机人姓名",
                                  label: "乘机人",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.passenger,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "passenger", $$v)
                                  },
                                  expression: "formData.passenger",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  rules: [
                                    {
                                      required: true,
                                      message: "出发城市不能为空",
                                    },
                                  ],
                                  required: true,
                                  name: "departureStation",
                                  placeholder: "请输入出发城市",
                                  label: "出发城市",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.departureStation,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "departureStation",
                                      $$v
                                    )
                                  },
                                  expression: "formData.departureStation",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  rules: [
                                    {
                                      required: true,
                                      message: "到达城市不能为空",
                                    },
                                  ],
                                  required: true,
                                  name: "arriveStation",
                                  placeholder: "请输入到达城市",
                                  label: "到达城市",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.arriveStation,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "arriveStation", $$v)
                                  },
                                  expression: "formData.arriveStation",
                                },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "van-cell-group",
                            { staticClass: "m-t-20" },
                            [
                              _c("van-field", {
                                attrs: {
                                  "input-align": "right",
                                  name: "invoiceType",
                                  rules: [
                                    {
                                      required: true,
                                      message: "发票类型不能为空",
                                    },
                                  ],
                                  required: true,
                                  value: _vm.formData.invoiceType,
                                  label: "发票类型",
                                  placeholder: "请选择发票类型",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "input",
                                    fn: function () {
                                      return [
                                        _c("view-item", {
                                          attrs: {
                                            value: _vm.formData.invoiceTypeName,
                                            placeholder: "请选择发票类型",
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              _vm.invoiceType.show = true
                                            },
                                          },
                                        }),
                                        _c(
                                          "van-popup",
                                          {
                                            attrs: { position: "bottom" },
                                            model: {
                                              value: _vm.invoiceType.show,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.invoiceType,
                                                  "show",
                                                  $$v
                                                )
                                              },
                                              expression: "invoiceType.show",
                                            },
                                          },
                                          [
                                            _c("van-nav-bar", {
                                              attrs: {
                                                title: "选择发票类型",
                                                "left-text": "取消",
                                                "right-text": "确定",
                                              },
                                              on: {
                                                "click-left": function (
                                                  $event
                                                ) {
                                                  _vm.invoiceType.show = false
                                                },
                                                "click-right": function (
                                                  $event
                                                ) {
                                                  return _vm.popupSubmit(
                                                    "invoiceType",
                                                    {
                                                      label: "dictLable",
                                                      value: "dictValue",
                                                    }
                                                  )
                                                },
                                              },
                                            }),
                                            _c("van-picker", {
                                              ref: "invoiceType",
                                              attrs: {
                                                "value-key": "dictLabel",
                                                columns: _vm.invoiceType.data,
                                              },
                                              on: {
                                                cancel: function ($event) {
                                                  _vm.invoiceType.show = false
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                              _c("van-field", {
                                attrs: {
                                  "input-align": "right",
                                  name: "invoiceTitle",
                                  rules: [
                                    {
                                      required: true,
                                      message: "发票抬头不能为空",
                                    },
                                  ],
                                  required: true,
                                  value: _vm.formData.invoiceTitle,
                                  label: "发票抬头",
                                  placeholder: "请选择发票抬头",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "input",
                                    fn: function () {
                                      return [
                                        _c("view-item", {
                                          attrs: {
                                            value: _vm.formData.invoiceTitle,
                                            placeholder: "请选择发票抬头",
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              _vm.invoiceTitle.show = true
                                            },
                                          },
                                        }),
                                        _c(
                                          "van-popup",
                                          {
                                            attrs: { position: "bottom" },
                                            model: {
                                              value: _vm.invoiceTitle.show,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.invoiceTitle,
                                                  "show",
                                                  $$v
                                                )
                                              },
                                              expression: "invoiceTitle.show",
                                            },
                                          },
                                          [
                                            _c("van-nav-bar", {
                                              attrs: {
                                                title: "选择发票抬头",
                                                "left-text": "取消",
                                                "right-text": "确定",
                                              },
                                              on: {
                                                "click-left": function (
                                                  $event
                                                ) {
                                                  _vm.invoiceTitle.show = false
                                                },
                                                "click-right": function (
                                                  $event
                                                ) {
                                                  return _vm.popupSubmit(
                                                    "invoiceTitle"
                                                  )
                                                },
                                              },
                                            }),
                                            _c("van-search", {
                                              attrs: {
                                                clearable: "",
                                                shape: "round",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.pickerSearch(
                                                    $event,
                                                    _vm.invoiceTitle,
                                                    "unitName"
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.invoiceTitle.filterText,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.invoiceTitle,
                                                    "filterText",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "invoiceTitle.filterText",
                                              },
                                            }),
                                            _c("van-picker", {
                                              ref: "invoiceTitle",
                                              attrs: {
                                                "value-key": "unitName",
                                                columns:
                                                  _vm.invoiceTitle.filteredData,
                                              },
                                              on: {
                                                cancel: function ($event) {
                                                  _vm.invoiceTitle.show = false
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                              _c("van-field", {
                                attrs: {
                                  rules: _vm.formRules.buyerTax,
                                  name: "buyerTax",
                                  required: true,
                                  maxlength: 20,
                                  placeholder: "请输入纳税人识别号",
                                  label: "纳税人识别号",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.buyerTax,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "buyerTax", $$v)
                                  },
                                  expression: "formData.buyerTax",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  type: "number",
                                  rules: [
                                    {
                                      required: true,
                                      message: "发票号码不能为空",
                                    },
                                  ],
                                  name: "invoiceCode",
                                  required: true,
                                  maxlength: 20,
                                  placeholder: "请输入发票号码",
                                  label: "发票号码",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.invoiceCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "invoiceCode", $$v)
                                  },
                                  expression: "formData.invoiceCode",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  rules: [
                                    {
                                      required: true,
                                      message: "开票日期不能为空",
                                    },
                                  ],
                                  required: true,
                                  name: "invoiceDate",
                                  label: "开票日期",
                                  placeholder: "开票日期",
                                  "input-align": "right",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "input",
                                    fn: function () {
                                      return [
                                        _c("view-item", {
                                          attrs: {
                                            value: _vm.formData.invoiceDate,
                                            placeholder: "请选择开票日期",
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              _vm.invoiceDate.show = true
                                            },
                                          },
                                        }),
                                        _c("van-calendar", {
                                          ref: "invoiceDate",
                                          attrs: {
                                            "min-date": _vm.invoiceDate.minDate,
                                            "show-confirm": false,
                                            title: "选择开票日期",
                                          },
                                          on: {
                                            confirm: _vm.invoiceDateConfirm,
                                          },
                                          model: {
                                            value: _vm.invoiceDate.show,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.invoiceDate,
                                                "show",
                                                $$v
                                              )
                                            },
                                            expression: "invoiceDate.show",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.formData.invoiceDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "invoiceDate", $$v)
                                  },
                                  expression: "formData.invoiceDate",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  "input-align": "right",
                                  name: "isElectronic",
                                  rules: [
                                    { required: true, message: "不能为空" },
                                  ],
                                  required: true,
                                  value: _vm.formData.isElectronic,
                                  label: "是否电子票",
                                  placeholder: "请选择是否电子票",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "input",
                                    fn: function () {
                                      return [
                                        _c("view-item", {
                                          attrs: {
                                            value:
                                              _vm.formData.isElectronicName,
                                            placeholder: "请选择是否电子票",
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              _vm.isElectronic.show = true
                                            },
                                          },
                                        }),
                                        _c(
                                          "van-popup",
                                          {
                                            attrs: { position: "bottom" },
                                            model: {
                                              value: _vm.isElectronic.show,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.isElectronic,
                                                  "show",
                                                  $$v
                                                )
                                              },
                                              expression: "isElectronic.show",
                                            },
                                          },
                                          [
                                            _c("van-nav-bar", {
                                              attrs: {
                                                title: "选择是否电子票",
                                                "left-text": "取消",
                                                "right-text": "确定",
                                              },
                                              on: {
                                                "click-left": function (
                                                  $event
                                                ) {
                                                  _vm.isElectronic.show = false
                                                },
                                                "click-right": function (
                                                  $event
                                                ) {
                                                  return _vm.popupSubmit(
                                                    "isElectronic",
                                                    {
                                                      label: "dictLable",
                                                      value: "dictValue",
                                                    }
                                                  )
                                                },
                                              },
                                            }),
                                            _c("van-picker", {
                                              ref: "isElectronic",
                                              attrs: {
                                                "value-key": "dictLabel",
                                                columns: _vm.isElectronic.data,
                                              },
                                              on: {
                                                cancel: function ($event) {
                                                  _vm.isElectronic.show = false
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                              _c("van-field", {
                                attrs: {
                                  type: "number",
                                  name: "invoiceAmount",
                                  rules: [
                                    {
                                      required: true,
                                      message: "价税合计金额不能为空",
                                    },
                                  ],
                                  required: true,
                                  maxlength: 20,
                                  placeholder: "价税合计金额",
                                  label: "价税合计金额",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.invoiceAmount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "invoiceAmount", $$v)
                                  },
                                  expression: "formData.invoiceAmount",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  type: "number",
                                  name: "taxAmount",
                                  required: true,
                                  maxlength: 20,
                                  rules: [
                                    { required: true, message: "税额不能为空" },
                                  ],
                                  placeholder: "税额",
                                  label: "税额",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.taxAmount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "taxAmount", $$v)
                                  },
                                  expression: "formData.taxAmount",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  type: "number",
                                  name: "taxExcludedAmount",
                                  required: true,
                                  rules: [
                                    {
                                      required: true,
                                      message: "不含税金额不能为空",
                                    },
                                  ],
                                  maxlength: 20,
                                  placeholder: "不含税金额",
                                  label: "不含税金额",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.taxExcludedAmount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "taxExcludedAmount",
                                      $$v
                                    )
                                  },
                                  expression: "formData.taxExcludedAmount",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  type: "number",
                                  name: "taxRate",
                                  required: true,
                                  maxlength: 20,
                                  rules: [
                                    { required: true, message: "税率不能为空" },
                                  ],
                                  placeholder: "请输入税率",
                                  label: "税率%",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.taxRate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "taxRate", $$v)
                                  },
                                  expression: "formData.taxRate",
                                },
                              }),
                              _c("van-field", {
                                attrs: {
                                  required: true,
                                  name: "seller",
                                  type: "textarea",
                                  maxlength: "200",
                                  rows: "3",
                                  rules: [
                                    {
                                      required: true,
                                      message: "销售方名称不能为空",
                                    },
                                  ],
                                  autosize: "",
                                  label: "销售方名称",
                                  "show-word-limit": "",
                                  placeholder: "请输入销售方名称",
                                  "input-align": "right",
                                },
                                model: {
                                  value: _vm.formData.seller,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "seller", $$v)
                                  },
                                  expression: "formData.seller",
                                },
                              }),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }